module.exports = __webpack_public_path__ + "pacient-white-i.png";